import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

export function* handleForgotPassword({ payload }) {
  try {
    const res = yield call(API.forgotPassword, payload.payloadData);
    const { data } = res;
    yield put(actions.forgotPasswordSuccess(data));
  } catch (err) {
    if (err?.response?.status === 404) {
      yield put(
        actions.forgotPasswordFailure({
          message: "The email used is not registered with us!!!",
        })
      );
    } else yield put(actions.forgotPasswordFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* forgotPasswordSaga() {
  yield takeLatest(actions.forgotPassword.type, handleForgotPassword);
}
